import React, { useEffect, useState } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { AlertCircle } from 'lucide-react';
interface VoidConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (authorizedBy: string, reason: string) => void;
  title?: string;
  description?: string;
  actionLabel?: string;
  isSubmitting?: boolean;
}
export function VoidConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Autorización Requerida',
  description = 'Esta acción requiere autorización. Por favor ingrese su nombre y el motivo de la anulación.',
  actionLabel = 'Confirmar Anulación',
  isSubmitting = false
}: VoidConfirmModalProps) {
  const [authorizedBy, setAuthorizedBy] = useState('');
  const [reason, setReason] = useState('');
  const handleConfirm = () => {
    if (authorizedBy.trim() && reason.trim()) {
      onConfirm(authorizedBy.trim(), reason.trim());
    }
  };
  // Reset state when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setAuthorizedBy('');
      setReason('');
    }
  }, [isOpen]);
  const isValid = authorizedBy.trim().length > 0 && reason.trim().length > 0;
  return <Modal isOpen={isOpen} onClose={onClose} title={title} overlayClassName="z-[200]" data-id="element-1504">
      <div className="space-y-4" data-id="element-1505">
        <div className="bg-red-50 text-red-800 p-3 rounded-md flex items-start gap-3" data-id="element-1506">
          <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" data-id="element-1507" />
          <p className="text-sm" data-id="element-1508">{description}</p>
        </div>

        <div className="space-y-3" data-id="element-1509">
          <div data-id="element-1510">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1511">
              Nombre de quien autoriza <span className="text-red-500" data-id="element-1512">*</span>
            </label>
            <Input value={authorizedBy} onChange={e => setAuthorizedBy(e.target.value)} placeholder="Ej. Juan Pérez (Gerente)" disabled={isSubmitting} data-id="element-1513" />
          </div>

          <div data-id="element-1514">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1515">
              Motivo de la anulación <span className="text-red-500" data-id="element-1516">*</span>
            </label>
            <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black resize-none" rows={3} value={reason} onChange={e => setReason(e.target.value)} placeholder="Ej. Cliente se retiró, Error de digitación, etc." disabled={isSubmitting} data-id="element-1517" />
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4" data-id="element-1518">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting} data-id="element-1519">
            Cancelar
          </Button>
          <Button variant="primary" className="bg-red-600 hover:bg-red-700 text-white border-transparent" onClick={handleConfirm} disabled={!isValid || isSubmitting} data-id="element-1520">
            {isSubmitting ? 'Procesando...' : actionLabel}
          </Button>
        </div>
      </div>
    </Modal>;
}